export class projectionKeys {
  keys = {
    "top_level": [
      "id",
      "facility_id",
      "account_name",
      "gatewayName",
      "displayName",
      "gatewayDetails",
      "status",
      "tag_data"
    ],
    "gateway": [
      "paytm_details",
      "hdfc_details",
      "razorpay_details",
      "iveri_light_details",
      "hdfc_Juspay_details"
    ],
    "paytm_details": [
      "id",
      "MID",
      "MERCHANT_KEY",
      "INDUSTRY_TYPE_ID",
      "WEBSITE",
      "THEME",
      "CALLBACK_URL",
      "PAYTM_URL",
      "CALLBACK_URL_MOBILE",
      "REQUEST_TYPE",
      "WEBSITE_NAME_WEB",
      "WEBSITE_NAME_MOBILE",
      "SHOW_PAGE_URL",
      "TOKEN_URL",
      "CURRENCY",
      "CHANNEL_ID_WEB",
      "CHANNEL_ID_MOBILE",
      "TRANSACTION_STATUS_URL",
      "PAYMENT_LINK_URL",
      "FETCH_LINK_URL",
      "EXPIRE_LINK_URL",
      "PAYMENT_LINK_CALLBACK_URL",
      "REFUND_INITIATE_URL",
      "REFUND_STATUS_URL"
    ],
    "hdfc_details": [
      "merchantId",
      "currency",
      "redirectURL",
      "cancelURL",
      "language",
      "accessCode",
      "actionURL"
    ],
    "razorpay_details": [
      "id",
      "merchantId",
      "currency",
      "redirectURL",
      "scriptURL",
      "cancelURL",
      "language",
      "responseType",
      "version",
      "keyId",
      "keySecret",
      "merchant_name",
      "description",
      "theme_color",
      "refundSpeed",
      "retryEnabled",
      "paymentLinkCallbackURL",
      "paymentLinkCallbackMethod",
      "paymentShortLinkURL",
      "acceptPartialPayment",
      "minFirstPartialPayment",
      "reminderEnable",
      "notifySMS",
      "notifyEmail",
      "paymentLinkUpdateURL",
      "paymentLinkFetchURL",
      "paymentLinkCancelURL"
    ],
    "iveri_light_details": [
      "id",
      "Lite_Merchant_ApplicationId",
      "Lite_Website_Successful_Url",
      "Lite_Website_Fail_Url",
      "Lite_Website_TryLater_Url",
      "Lite_Website_Error_Url",
      "Lite_ConsumerOrderID_PreFix",
      "Ecom_Payment_Card_Protocols",
      "Ecom_TransactionComplete",
      "Lite_Currency_AlphaCode",
      "ShowModal",
      "convertor",
      "redirect_url"
    ],
    "hdfc_Juspay_details": [
      "id",
      "customerId",
      "payment_page_client_id",
      "CALLBACK_URL",
      "merchantId",
      "currency",
      "action",
      "key_UUID",
      "base_url",
      "private_key",
      "public_key",
      "linkExpiry",
      "email_required",
      "send_sms",
      "API_KEY",
      "RESPONSE_KEY",
      "extra_data"
    ]
  }
}